<template>
  <div class="row">
    <div class="col-md-12" :class="usage !== 'questions' ? [validatedSectionClass, generalClass] : ''">
      <div :class="usage !== 'questions' ? 'row' : ''">
        <div v-if="usage !== 'questions'" class="col-md-10 col-md-offset-1">
          <label class="control-label" :class="required || required === undefined ? 'required' : ''" for="kit_number">
            {{computeReportableCaption('kit_number', this.fields_en['kit_number'], this.$store.state.lang.value.toLowerCase())}}
          </label>
        </div>
      </div>
      <div class="row">
        <div>
          <div
              :class= "(computeCaption(fields_en['scan'], this.$store.state.lang.value.toLowerCase())).length === 0 ?
              (usage !== 'questions' ? 'col-md-2 col-md-offset-1 col-sm-2 col-xs-2' : 'col-md-4 col-sm-2 col-xs-2') :
              (usage !== 'questions' ? 'col-md-2 col-md-offset-1 col-sm-12 col-xs-12' : 'col-md-4 col-sm-12 col-xs-12')">
            <div class="form-group">
              <el-button icon="el-icon-camera-solid" class="w-100 primary-color primary-border" @click="() => {drawer=true; disabledKitNumber = false}"><br v-if="usage === 'questions' && !isMobile()"><span class="text-button">{{this.$store.state.translation['Scan'] && this.$store.state.translation['Scan'][this.$store.state.lang.value.toLowerCase()].length === 0 ? '' : computeCaption(fields_en['scan'], this.$store.state.lang.value.toLowerCase())}}</span></el-button>
              <el-drawer
                :with-header="false"
                :append-to-body="true"
                :visible.sync="drawer"
                direction="ltr"
                size="100%"
              >
                <HomekitScanner  v-if="drawer" v-on:closeScanner="closeScanner" v-on:getScannedData="getScannedData"/>
              </el-drawer>
            </div>
          </div>
          <div class='col-md-8'
              :class= "(computeCaption(fields_en['scan'], this.$store.state.lang.value.toLowerCase())).length === 0 ?
              ('col-sm-10 col-xs-10') :
              ( usage !== 'questions' ? 'col-sm-12 col-xs-12' : 'col-sm-12 col-xs-12' )">
            <div class="form-group">
              <input class="form-control"
                     id="kit_number"
                     type="text"
                     data-vv-as="Kit Number"
                     :name="usage !== 'questions' ? 'kit_number' : model.kit_number === '' ? 'invalidQuestion' : ''"
                     :disabled="disabledKitNumber"
                     v-validate="modelValidations.kit_number"
                     v-model="model.kit_number"
                     @blur="checkKitNumberOnBlur"
                     :placeholder="disabledKitNumber ? (text_ph !== undefined ? computeCaption(text_ph, this.$store.state.lang.value.toLowerCase()) : computeCaption(fields_en.place_holder, this.$store.state.lang.value.toLowerCase())) : 'Please type the barcode value here'"
                     onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
              />

            </div>
          </div>
        </div>
      <div class="form-group">
        <div class="col-md-10 col-md-offset-1 default-grey font-small" v-if="usage !== 'questions'" v-show="getFieldDescription('kit_number')" v-html="getFieldDescription('kit_number') || ''"></div>
        <small class="col-md-10 col-xs-12 col-md-offset-1 text-danger" v-show="kit_error">
          {{ computeCaption(kit_error, this.$store.state.lang.value.toLowerCase()) }}
        </small>
      </div>
      </div>
      <div v-if="usage !== 'questions'">
        <br><br></div>
  </div>
  </div>
</template>

<script>
import HomekitScanner from '../../dynamo/HomekitScanner'
import { Drawer, Button } from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {ValidationUtils} from '../../../../../../utils/Validation'
import {AccessionUtils} from '../../../../../../utils/AccessionDetailsProcessing'
import axios from 'axios'

export default {
  mixins: [TranslationsUtils, ValidationUtils, AccessionUtils],
  components: {
    HomekitScanner,
    [Drawer.name]: Drawer,
    [Button.name]: Button
  },
  props: {
    usage: {default: undefined},
    question: {default: undefined},
    required: {default: undefined},
    text_ph: {default: undefined}
  },
  data () {
    return {
      kitNumberValidByInventory: !this.$store.state.configs.VALIDATE_KIT_NUMBER_BY_INVENTORY,
      disabledKitNumber: false,
      generalClass: 'general-inactive-section',
      kit_error: '',
      validatedSectionClass: '',
      disabled: false,
      drawer: false,
      fields_en: {
        kit_number: 'Kit Number',
        place_holder: 'Use scan button or type Kit Number',
        scan: 'Scan'
      },
      model: {
        kit_number: ''
      },
      modelValidations: {
        kit_number: {
          required: true,
          max: 25,
          min: 2
        }
      }
    }
  },
  beforeMount () {
    if (this.required !== undefined) {
      this.modelValidations.kit_number.required = this.required
    }
    this.disabledKitNumber = this.isMobile()
  },
  methods: {
    checkKitNumberOnBlur: async function (e) {
      let valid
      if (this.$store.state.configs.VALIDATE_KIT_NUMBER_BY_INVENTORY === true && this.usage !== 'questions' && this.required) {
        const kitNo = e.target.value
        if (kitNo !== '' && kitNo.length >= 2) {
          valid = await this.validateKitNumberByInvetory(kitNo)
          if (valid) {
            this.kit_error = ''
            this.validatedSectionClass = 'validated-section-class'
            this.generalClass = 'general-inactive-section'
          } else {
            this.kit_error = 'The kit number is invalid'
            this.validatedSectionClass = 'invalid-section-class'
            this.generalClass = 'general-invalid-section'
          }
        }
      }
    },
    async validateKitNumberByInvetory (kitNumber) {
      let valid = false
      await axios.get(process.env.SERVER_URI + '/validate_kit_number/' + kitNumber)
        .then((response) => {
          if (response.data === true) {
            valid = true
          }
        }).catch((error) => {
          console.log(error)
        })
      return valid
    },
    closeScanner () {
      this.drawer = false
    },
    getScannedData (data) {
      this.drawer = false
      this.model.kit_number = data
    },
    async validate () {
      if (this.$store.state.configs.VALIDATE_KIT_NUMBER_BY_INVENTORY === true && this.usage !== 'questions' && this.required) {
        this.kitNumberValidByInventory = await this.validateKitNumberByInvetory(this.model.kit_number)
      } else {
        this.kitNumberValidByInventory = true
      }
      if (this.kitNumberValidByInventory && this.model.kit_number && this.model.kit_number.length <= this.modelValidations.kit_number.max || !this.required && this.required !== undefined) {
        this.kit_error = ''
        return this.model.kit_number
      } else {
        this.kit_error = this.kitNumberValidByInventory ? 'Please Scan your kit number' : 'The kit number is invalid'
        let elem = document.getElementsByName('kit_number')[0]
        if (elem.disabled) {
          let panel = document.getElementsByClassName('main-panel')[0]
          let top = elem.getBoundingClientRect().top
          panel.scrollTop = panel.scrollTop + top - 130
        } else {
          elem.focus()
        }
        return false
      }
    }
  },
  watch: {
    'model.kit_number': {
      handler: function (after, before) {
        if (this.usage !== 'questions') {
          if (this.kitNumberValidByInventory && this.model.kit_number && this.model.kit_number.length <= this.modelValidations.kit_number.max || !this.required && this.required !== undefined) {
            this.validatedSectionClass = 'validated-section-class'
            this.generalClass = 'general-inactive-section'
            this.kit_error = ''
          } else {
            if (this.model.kit_number.length > this.modelValidations.kit_number.max) {
              this.kit_error = `This field has a maximum of ${this.modelValidations.kit_number.max} characters`
            } else {
              this.kit_error = this.kitNumberValidByInventory ? 'Please Scan your kit number' : 'The kit number is invalid'
            }
            this.validatedSectionClass = 'invalid-section-class'
            this.generalClass = 'general-invalid-section'
          }
        } else {
          if (this.question) {
            if (this.model.kit_number.length <= this.modelValidations.kit_number.max && this.model.kit_number.length >= this.modelValidations.kit_number.min) {
              this.question.value = this.model.kit_number
              this.kit_error = ''
            } else if (this.model.kit_number.length > this.modelValidations.kit_number.max) {
              this.question.value = ''
              this.kit_error = `This field has a maximum of ${this.modelValidations.kit_number.max} characters`
            } else {
              this.question.value = ''
              this.kit_error = 'Please Scan or input your sample number'
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../assets/sass/paper/variables";
.w-100{
  width: 100%;
}

.scan-button{
  font-size: 17px;
  background: white;
  border-radius: 5px;
}

.f-right{
  float: right;
}

.mt-10{
  margin-top: 10px;
}
.mt-15 {
  margin-top: 15px;
}
.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}

.text-button {
  white-space: normal;
  overflow-wrap: break-word;
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/MultipleUseParts/ScanningModule.vue